<template>
  <div style="display: flex; justify-content: space-between;">
    <ImageNumber ref="v7"></ImageNumber>
    <ImageNumber ref="v6"></ImageNumber>
    <ImageNumber ref="v5"></ImageNumber>
    <ImageNumber ref="v4"></ImageNumber>
    <ImageNumber ref="v3"></ImageNumber>
    <ImageNumber ref="v2"></ImageNumber>
    <ImageNumber ref="v1"></ImageNumber>
  </div>
</template>

<script>
import ImageNumber from "./ImageNumber";

export default {
  name: "ImageNumbers",
  components: {ImageNumber},
  data() {
    return {
      value: 0
    }
  },
  methods: {
    setValue: function (v) {
      this.value = v
      this.$refs["v7"].setValue(Math.floor(v / 1000000 % 10))
      this.$refs["v6"].setValue(Math.floor(v / 100000 % 10))
      this.$refs["v5"].setValue(Math.floor(v / 10000 % 10))
      this.$refs["v4"].setValue(Math.floor(v / 1000 % 10))
      this.$refs["v3"].setValue(Math.floor(v / 100 % 10))
      this.$refs["v2"].setValue(Math.floor(v / 10 % 10))
      this.$refs["v1"].setValue(Math.floor(v % 10))
    },
    getValue: function (){
      return this.value
    }
  }
}
</script>

<style scoped>

</style>
